import {TaskBoardCard, TaskBoardColumn} from "../../../api/Tasks2";
import {useContext} from "react";
import {BoardContext} from "../BoardContextProvider";
import {useSyncedRef} from "../../../misc/SyncedRef";
import {useAsync2, useAsyncAction} from "nate-react-api-helpers";
import {api} from "../../../api/API";
import {Menu, MenuItem} from "@mui/material";

export function ChooseBoardStatus(props: {
    card: TaskBoardCard;
    anchorEl: any;
    column: TaskBoardColumn
    onClose(all?: boolean): void;
}) {
    const ctx = useContext(BoardContext);
    const ctxRefreshColumns = useSyncedRef(ctx.refreshColumnsEmitter);

    const boardInfo = useAsync2(input => api.tasks2.getBoard(input), {
        id: props.column.board
    }, [props.column.board]);

    const onCloseRef = useSyncedRef(props.onClose)
    const updateColumn = useAsyncAction(async (input) => {
        await api.tasks2.updateCard(input);
        ctxRefreshColumns.current.emit(true);
        onCloseRef.current(true);
    }, []);

    return (
        <Menu open anchorEl={props.anchorEl} onClose={() => props.onClose()}>
            {boardInfo.LoadingOrErrorElement}
            {boardInfo.result?.columns?.map(c => (
                <MenuItem key={c.id} onClick={() => {
                    updateColumn.callback(Object.assign({}, props.card, {
                        boardColumn: c.id,
                        sortOrder: 0,
                    }));
                }}>
                    {c.title}
                </MenuItem>
            ))}

            {updateColumn.LoadingElement}
        </Menu>
    )
}